<!-- <div id="loader" *ngIf="isLoader">
  <div class="burger"></div>
  <h4><b>Cooking data...</b></h4>
</div> -->


<div *ngIf="body">
  <mat-card style="background: transparent;">
    <mat-card class="card_style">
      <div style="text-align: center; padding-top: 50px;">
        <h1 style="margin-top: -18px;"><b>Market Study - Decorative Coatings</b></h1>
      </div>

      <div style="text-align:left;">
        <div style="margin-bottom: 2%;">
          <img class="excel-button" 
               src="https://cdn-icons-png.flaticon.com/128/732/732220.png" 
               width="35" height="35" 
               (click)="excelExport()">
        </div>
       
      <!-- Filters
        <div class="d-flex mb-3">
          <div class="filter-dropdown">
            <label class="label-filter">Country:</label>
            <ng-select placeholder="Select Country" class="me-3"
              [items]="country_drop" (change)="countrySelected()"
              [(ngModel)]="search_filter.marketing_country_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>
          <div class="filter-dropdown">
            <label class="label-filter">State:</label>
            <ng-select placeholder="Select State" class="me-3"
              [items]="statedrop" (change)="stateSelected()"
              [(ngModel)]="search_filter.marketing_state_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>
          <div class="filter-dropdown">
            <label class="label-filter">Area:</label>
            <ng-select placeholder="Select Area" class="me-3"
              [items]="areadrop" (change)="areaSelected()"
              [(ngModel)]="search_filter.marketing_area_id"
              bindLabel="name" bindValue="_id"></ng-select>
          </div>
          <div class="filter-dropdown">
            <label class="label-filter">Customer:</label>
            <input type="text" [(ngModel)]="search_filter.customer_name"
              (ngModelChange)="customerSelected()" class="form-control me-3" />
          </div>
        </div> -->
        
        <div class="table-responsive">
          <table class="table" id="MarketStudy">
            <thead>
  <tr>
    <th>Dealer Name</th>
    <th>Location (Latitude, Longitude)</th>
    <th>Owner Name</th>
    <th>WhatsApp Number</th>
    <th>Owner Nationality</th>
    <th>Store Type</th>
    <th>Procurement Source</th>
    <th>Retailer/Wholesaler</th>
    <th>Customer Type</th>
    <th>Supplier Payment Mode</th>
    <th>Customer Payment Mode</th>
    <th>Credit Days (Given by Companies)</th>
    <th>Credit Days (Given to Customers)</th>
    <th>Brands & Monthly Purchase Value</th>
    <th>Painter/Contractor Meets</th>
    <th>Promotional Activities</th>
    <th>Offers for Purchases</th>
    <th>Uses Tinting Machine</th>
    <th>Wood Coatings Preferred Brand</th>
    <th>Reason</th>
    <th>Emulsions Preferred Brand</th>
    <th>Reason</th>
    <th>Water Based Primers Preferred brand</th>
    <th>Reason</th>
    <th>Enamels Preferred Brand</th>
    <th>Reason</th>
    <th>Expectations from Suppliers</th>
    
    <th>(Exterior Emulsions Economy) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>(Exterior Emulsions Premium) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>(Exterior Emulsions Luxury) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>(Interior Emulsions Economy) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>(Interior Emulsions Premium) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>(Interior Emulsions Luxury) Brand Name</th>
    <th>Avg Monthly Volume</th>
    <th>Price</th>
    
    <th>PVA Primer (Name)</th>
    <th>PVA Primer (Avg Monthly Volume)</th>
    <th>PVA Primer (Price)</th>
    
    <th>Acrylic Primer (Name)</th>
    <th>Acrylic Primer (Avg Monthly Volume)</th>
    <th>Acrylic Primer (Price)</th>

    <th>Enamels (Name)</th>
    <th>Enamels (Avg Monthly Volume)</th>
    <th>Enamels (Price)</th>
    
    <th>PU Clear (Name)</th>
    <th>PU Clear (Avg Monthly Volume)</th>
    <th>PU Clear (Price)</th>

    <th>PU Sealer (Name)</th>
    <th>PU Sealer (Avg Monthly Volume)</th>
    <th>PU Sealer (Price)</th>

    <th>PU Paint (Name)</th>
    <th>PU Paint (Avg Monthly Volume)</th>
    <th>PU Paint (Price)</th>

    <th>PU Primer (Name)</th>
    <th>PU Primer (Avg Monthly Volume)</th>
    <th>PU Primer (Price)</th>

    <th>NC Paint (Name)</th>
    <th>NC Paint (Avg Monthly Volume)</th>
    <th>NC Paint (Price)</th>

    <th>NC Primer (Name)</th>
    <th>NC Primer (Avg Monthly Volume)</th>
    <th>NC Primer (Price)</th>

    <th>NC Clear (Name)</th>
    <th>NC Clear (Avg Monthly Volume)</th>
    <th>NC Clear (Price)</th>

    <th>NC Sanding Sealer (Name)</th>
    <th>NC Sanding Sealer (Avg Monthly Volume)</th>
    <th>NC Sanding Sealer (Price)</th>

    <th>NC Thinner (Name)</th>
    <th>NC Thinner (Avg Monthly Volume)</th>
    <th>NC Thinner (Price)</th>

    <th>PU Thinner (Name)</th>
    <th>PU Thinner (Avg Monthly Volume)</th>
    <th>PU Thinner (Price)</th>

    <th>Acrylic Thinner (Name)</th>
    <th>Acrylic Thinner (Avg Monthly Volume)</th>
    <th>Acrylic Thinner (Price)</th>

    <th>Universal Lacquer Thinner (Name)</th>
    <th>Universal Lacquer Thinner (Avg Monthly Volume)</th>
    <th>Universal Lacquer Thinner (Price)</th>

  </tr>
</thead>

<tbody>
  <tr *ngFor="let employee of output">
    <td>{{ employee?.customer_name }}</td>
    <td>{{ employee?.latitude }}, {{ employee?.longitude }}</td>
    <td>{{ employee?.owners_name }}</td> 
    <td>{{ employee?.whatsapp_number }}</td>
    <td>{{ employee?.owners_nationality }}</td>
    <td>{{ employee?.store_type }}</td>
    <td>{{ employee?.where_procure_paints_from }}</td>
    <td>{{ employee?.retailer_or_wholesaler }}</td>
    <td>{{ employee?.customer_type }}</td>
    <td>{{ employee?.payment_mode_to_suppliers }}</td>
    <td>{{ employee?.payment_mode_from_customers }}</td>
    <!-- credit_days_given_by_companies -->
    <td>
      <ng-container *ngIf="employee?.credit_days_given_by_companies?.length; else noData">
        <span *ngFor="let c of employee.credit_days_given_by_companies; let i = index">
          {{ c.days }}<span *ngIf="i < employee.credit_days_given_by_companies.length - 1">, </span>
        </span>
      </ng-container>
    </td>

    <!-- credit_days_given_to_customers (single value, unchanged) -->
    <td>{{ employee?.credit_days_given_to_customers }}</td>

    <!-- brands_monthly_purchase -->
    <td>
      <ng-container *ngIf="employee?.brands_monthly_purchase?.length; else noData">
        <div *ngFor="let b of employee.brands_monthly_purchase">
          {{ b.brand_name }} - {{ b.avg_monthly_value || ' ' }}
        </div>
      </ng-container>
    </td>
    <td>{{ employee?.conducts_painter_meets }}</td>
    <td>{{ employee?.promotional_activities }}</td>
    <td>{{ employee?.suppliersOffersSchemeBased }}</td>
    <td>{{ employee?.uses_tinting_machine }}</td>
    
    <td>{{ employee?.wood_coatings_preferred_brand }}</td>
    <td>{{ employee?.wood_coatings_reason }}</td>
    
    <td>{{ employee?.emulsions_preferred_brand }}</td>
    <td>{{ employee?.emulsions_reason }}</td>
    
    <td>{{ employee?.water_based_primers_preferred_brand }}</td>
    <td>{{ employee?.water_based_primers_reason }}</td>
    
    <td>{{ employee?.enamels_preferred_brand }}</td>
    <td>{{ employee?.enamels_reason }}</td>
    <td>{{ employee?.expectations_from_suppliers }}</td>

    <td colspan="3">
    <ng-container *ngIf="employee?.exterior_emulsions_economy?.length; else noData">
      <div *ngFor="let e of employee.exterior_emulsions_economy">
        {{ e.name || ' ' }} - {{ e.avgMonthlyVolume || ' ' }} - {{ e.price || ' ' }}
      </div>
    </ng-container>
  </td>

    <!-- exterior_emulsions_premium -->
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_premium">{{ e.name || ' ' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_premium">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_premium">{{ e.price || '' }}</div>
      </ng-container>
    </td>

    <!-- exterior_emulsions_luxury -->
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_luxury">{{ e.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_luxury">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.exterior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.exterior_emulsions_luxury">{{ e.price || '' }}</div>
      </ng-container>
    </td>

    <!-- interior_emulsions_economy -->
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_economy?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_economy">{{ e.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_economy?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_economy">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_economy?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_economy">{{ e.price || '' }}</div>
      </ng-container>
    </td>

    <!-- interior_emulsions_premium -->
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_premium">{{ e.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_premium">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_premium?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_premium">{{ e.price || '' }}</div>
      </ng-container>
    </td>

    <!-- interior_emulsions_luxury -->
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_luxury">{{ e.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_luxury">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.interior_emulsions_luxury?.length; else noData">
        <div *ngFor="let e of employee.interior_emulsions_luxury">{{ e.price || '' }}</div>
      </ng-container>
    </td> 

    <!-- pva_primer -->
    <td>
      <ng-container *ngIf="employee?.pva_primer?.length; else noData">
        <div *ngFor="let p of employee.pva_primer">{{ p.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pva_primer?.length; else noData">
        <div *ngFor="let p of employee.pva_primer">{{ p.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pva_primer?.length; else noData">
        <div *ngFor="let p of employee.pva_primer">{{ p.price || '' }}</div>
      </ng-container>
    </td>

    <!-- acrylic_primer -->
    <td>
      <ng-container *ngIf="employee?.acrylic_primer?.length; else noData">
        <div *ngFor="let a of employee.acrylic_primer">{{ a.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.acrylic_primer?.length; else noData">
        <div *ngFor="let a of employee.acrylic_primer">{{ a.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.acrylic_primer?.length; else noData">
        <div *ngFor="let a of employee.acrylic_primer">{{ a.price || '' }}</div>
      </ng-container>
    </td>

    <!-- enamels -->
    <td>
      <ng-container *ngIf="employee?.enamels?.length; else noData">
        <div *ngFor="let e of employee.enamels">{{ e.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.enamels?.length; else noData">
        <div *ngFor="let e of employee.enamels">{{ e.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.enamels?.length; else noData">
        <div *ngFor="let e of employee.enamels">{{ e.price || '' }}</div>
      </ng-container>
    </td> 

    <!-- pu_clear -->
    <td>
      <ng-container *ngIf="employee?.pu_clear?.length; else noData">
        <div *ngFor="let item of employee.pu_clear">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_clear?.length; else noData">
        <div *ngFor="let item of employee.pu_clear">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_clear?.length; else noData">
        <div *ngFor="let item of employee.pu_clear">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- pu_sealer -->
    <td>
      <ng-container *ngIf="employee?.pu_sealer?.length; else noData">
        <div *ngFor="let item of employee.pu_sealer">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_sealer?.length; else noData">
        <div *ngFor="let item of employee.pu_sealer">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_sealer?.length; else noData">
        <div *ngFor="let item of employee.pu_sealer">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- pu_paint -->
    <td>
      <ng-container *ngIf="employee?.pu_paint?.length; else noData">
        <div *ngFor="let item of employee.pu_paint">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_paint?.length; else noData">
        <div *ngFor="let item of employee.pu_paint">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_paint?.length; else noData">
        <div *ngFor="let item of employee.pu_paint">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- pu_primer -->
    <td>
      <ng-container *ngIf="employee?.pu_primer?.length; else noData">
        <div *ngFor="let item of employee.pu_primer">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_primer?.length; else noData">
        <div *ngFor="let item of employee.pu_primer">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_primer?.length; else noData">
        <div *ngFor="let item of employee.pu_primer">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- nc_paint -->
    <td>
      <ng-container *ngIf="employee?.nc_paint?.length; else noData">
        <div *ngFor="let item of employee.nc_paint">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_paint?.length; else noData">
        <div *ngFor="let item of employee.nc_paint">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_paint?.length; else noData">
        <div *ngFor="let item of employee.nc_paint">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- nc_primer -->
    <td>
      <ng-container *ngIf="employee?.nc_primer?.length; else noData">
        <div *ngFor="let item of employee.nc_primer">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_primer?.length; else noData">
        <div *ngFor="let item of employee.nc_primer">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_primer?.length; else noData">
        <div *ngFor="let item of employee.nc_primer">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- nc_clear -->
    <td>
      <ng-container *ngIf="employee?.nc_clear?.length; else noData">
        <div *ngFor="let item of employee.nc_clear">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_clear?.length; else noData">
        <div *ngFor="let item of employee.nc_clear">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_clear?.length; else noData">
        <div *ngFor="let item of employee.nc_clear">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- nc_sanding_sealer -->
    <td>
      <ng-container *ngIf="employee?.nc_sanding_sealer?.length; else noData">
        <div *ngFor="let item of employee.nc_sanding_sealer">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_sanding_sealer?.length; else noData">
        <div *ngFor="let item of employee.nc_sanding_sealer">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_sanding_sealer?.length; else noData">
        <div *ngFor="let item of employee.nc_sanding_sealer">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- nc_thinner -->
    <td>
      <ng-container *ngIf="employee?.nc_thinner?.length; else noData">
        <div *ngFor="let item of employee.nc_thinner">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_thinner?.length; else noData">
        <div *ngFor="let item of employee.nc_thinner">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.nc_thinner?.length; else noData">
        <div *ngFor="let item of employee.nc_thinner">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- pu_thinner -->
    <td>
      <ng-container *ngIf="employee?.pu_thinner?.length; else noData">
        <div *ngFor="let item of employee.pu_thinner">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_thinner?.length; else noData">
        <div *ngFor="let item of employee.pu_thinner">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.pu_thinner?.length; else noData">
        <div *ngFor="let item of employee.pu_thinner">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- acrylic_thinner -->
    <td>
      <ng-container *ngIf="employee?.acrylic_thinner?.length; else noData">
        <div *ngFor="let item of employee.acrylic_thinner">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.acrylic_thinner?.length; else noData">
        <div *ngFor="let item of employee.acrylic_thinner">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.acrylic_thinner?.length; else noData">
        <div *ngFor="let item of employee.acrylic_thinner">{{ item.price || '' }}</div>
      </ng-container>
    </td>

    <!-- universal_lacquer_thinner -->
    <td>
      <ng-container *ngIf="employee?.universal_lacquer_thinner?.length; else noData">
        <div *ngFor="let item of employee.universal_lacquer_thinner">{{ item.name || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.universal_lacquer_thinner?.length; else noData">
        <div *ngFor="let item of employee.universal_lacquer_thinner">{{ item.avgMonthlyVolume || '' }}</div>
      </ng-container>
    </td>
    <td>
      <ng-container *ngIf="employee?.universal_lacquer_thinner?.length; else noData">
        <div *ngFor="let item of employee.universal_lacquer_thinner">{{ item.price || '' }}</div>
      </ng-container>
    </td>                                 
  </tr>
</tbody>

<!-- fallback -->
<ng-template #noData></ng-template>

          </table>
        </div>
      </div>
    </mat-card>
  </mat-card>
</div>
